'use strict';

var util = require('util');

var implementation = require('./implementation');

module.exports = function getPolyfill() {
  if (typeof util.promisify === 'function') {
    return util.promisify;
  }

  return implementation;
};